import type { SiteConfig } from '@/temporary-site-config';
import type { Article } from '@/components/ArticleList/types';
import { getPostCategories } from '@/utils/get-post-categories';
import {
	makeAdUnitPathPrefix,
	type SiteConfig as TempestSiteConfig,
} from 'tempest-common';

type OptionalArticle = Article | undefined;

const getSectionKey = (article: OptionalArticle, path: string) => {
	if (article) {
		const categories = getPostCategories(article);
		if (!categories.primary) {
			return 'homepage';
		}
		return categories.primary.slug;
	}
	if (path === '/') {
		return 'homepage';
	}
	return path.replace(/^\/([^/]+)\/?.*/, '$1');
};

export const makeAdUnitPath = (
	article: OptionalArticle,
	path: string,
	siteConfig: SiteConfig,
): string => {
	const contentItem = {
		externalReferences: [{ source: '' }],
		isReadOnlyContent: false,
		section: {
			sectionKey: getSectionKey(article, path),
		},
	};
	const adUnitPath = makeAdUnitPathPrefix(
		siteConfig as unknown as TempestSiteConfig,
		contentItem,
	);
	return adUnitPath.replace('//', '/');
};
